import {Injectable} from '@angular/core';
import {Country, facadeFactory} from '@spartacus/core';
import {UserProfileFacade, USER_PROFILE_CORE_FEATURE} from '@spartacus/user/profile/root';
import {Observable} from 'rxjs';
import {DocumentIdentifierType, JobType, UserTaxGroup} from 'src/app/spartacus/spartacus-custom.module';

export function CustomUserProfileFacadeFactory() {
  return facadeFactory({
    facade: CustomUserProfileFacade,
    feature: USER_PROFILE_CORE_FEATURE,
    methods: ['get', 'update', 'close', 'getTitles', 'getCountries', 'getJobTypes',  'getDocumentIdentifierTypes'],
  });
}

@Injectable({
  providedIn: 'root',
  useFactory: CustomUserProfileFacadeFactory,
})
export abstract class CustomUserProfileFacade extends UserProfileFacade {

  abstract getCountries(): Observable<Country[]>;
  abstract getUserTaxGroups(): Observable<UserTaxGroup[]>;
  abstract getJobTypes(): Observable<JobType[]>;

  abstract getDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]>;

}
